<template>
  <div :class="carouselClass">
    <h2
      v-if="title"
      class="c-collection-card-carousel-title t-heading-5 u-text-align-center"
    >
      {{ title }}
    </h2>
    <h3
      v-if="subtitle"
      class="c-collection-card-carousel-subtitle u-text-align-center"
    >
      {{ subtitle }}
    </h3>
    <div
      v-if="flickityActive"
      class="c-collection-card-carousel__active-carousel"
    >
      <flickity
        ref="flickity"
        class="flickity"
        :options="flickityOptions"
      >
        <template v-for="(card, index) in cards">
          <a
            :key="index"
            class="carousel-cell"
            :href="card.directUrl"
          >
            <content-card
              v-bind="card"
            />
          </a>
        </template>
      </flickity>
    </div>
    <div
      v-else
      class="c-collection-card-carousel__disabled-carousel l-grid l-grid--4-col-min-2"
    >
      <template v-for="(card, index) in cards">
        <a
          :key="index"
          class="carousel-cell"
          :href="card.directUrl"
        >
          <content-card
            v-bind="card"
          />
        </a>
      </template>
    </div>
    <btn
      v-if="cta"
      v-bind="cta"
      class="c-collection-card-carousel__btn"
    >
      {{ cta.text }}
    </btn>
  </div>
</template>

<script>
import Btn from "@/components/button/Btn";
import flickityActive  from './flickityActive'
import ContentCard from "../card/ContentCard";

export default {
  name: "FeaturedCollection",
  components: {
    ContentCard,
    Btn
  },
  mixins: [
    flickityActive
  ],
  props: {
    title: {
      type: String,
      default: null
    },
    subtitle: {
      type: String,
      default: null
    },
    cards: {
      type: Array,
      default: () => []
    },
    cta: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      carouselStart: true,
      carouselEnd: false,
      nextButtonDisabled: null,
      flickityOptions: {
        prevNextButtons: true,
        pageDots: true,
        wrapAround: true,
        freeScroll: true,
        cellAlign: 'left',
        imagesLoaded: true,
        // any options from Flickity can be used
        // https://flickity.metafizzy.co/options.html
      }
    }
  },
  computed: {
    carouselClass() {
      let results = ['c-collection-card-carousel'];
      return results;
    },
  },
  watch: {
    async cards() {
      await this.$nextTick()
      this.flickityActivator();
    }
  },
  mounted() {
    // this set interval is created as this.$refs.flickity.$flickity is created in mounted but not soon enough to be accessed strait from mounted.
    const checkFlickity = setInterval(() => {
      if (this.$refs.flickity.$flickity) {
        this.$refs.flickity.$flickity.on('change', this.updateCarouselLocation);
        clearInterval(checkFlickity);
      }
    }, 1000);
  },
  methods: {
    updateCarouselLocation() {
      this.carouselStart = this.$el.getElementsByClassName('flickity-prev-next-button previous')[0].disabled;
      this.carouselEnd = this.$el.getElementsByClassName('flickity-prev-next-button next')[0].disabled;
    },
    flickityActivator() {
      if (this.cards.length > 4) {
        this.flickityActive = true;
        return
      }
      if (window.innerWidth < 900) {
        if (this.cards.length > 2) {
          this.flickityActive = true;
          return
        }
      }
      this.flickityActive = false;
      return
    },
  },
  beforeDestory() {
    window.removeEventListener("change", this.updateCarouselLocation);
  },
}
</script>

<style lang="scss">
.c-collection-card-carousel {
  position : relative;
  width: 90%;
  margin: auto;
  text-align: center;
  &-title {
    margin-top: 30px;
  }
  &-subtitle {
    margin: 30px 0px;
  }
  &--end-fade {
    &:after {
      content  : "";
      position : absolute;
      z-index  : 1;
      top: 0;
      right   : 0;
      pointer-events   : none;
      background-image : linear-gradient(to right,
          rgba(255,255,255, 0),
          rgba(255,255,255, 1) 90%);
      width    : rem(200px);
      height   : 100%;
      @include respond(phone) {
        width    : rem(150px);
      }
    }
  }

  &--start-fade {
    &:before {
      content  : "";
      position : absolute;
      z-index  : 1;
      top: 0;
      left   : 0;
      pointer-events   : none;
      background-image : linear-gradient(to left,
          rgba(255,255,255, 0),
          rgba(255,255,255, 1) 90%);
      width    : rem(200px);
      height   : 100%;
      @include respond(phone) {
        width    : rem(150px);
      }
    }
  }

  //flickity style overrides
  &__active-carousel {
    .flickity {
      &:focus-visible {
        outline: none !important;
      }
    }
    .carousel-cell {
      width: 25%;
      padding-right: rem(20px);
      @include respond(tab-port) {
        width: 50%;
      }
    }
    .flickity-prev-next-button {
     z-index: 2;
      &:disabled {
        display: none;
      }
    }
    .flickity-prev-next-button.next {
      right: rem(-35px);
      @media only screen and (max-width: 1700px) {
        right: rem(30px);
      }
    }
    .flickity-prev-next-button.previous {
      left: rem(-35px);
      @media only screen and (max-width: 1700px) {
        left: 10px;
      }
    }
  }
  &__btn {
    margin-top: 30px;
  }
}
</style>